"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.purry = function (func) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1) {
      return function (arg2) {
        if (typeof args[0] === 'function' && typeof arg2 === 'object') {
          return func(arg2, args[0]);
        }

        if (typeof args[0] === 'object' && typeof arg2 === 'function') {
          return func(args[0], arg2);
        }

        throw new Error('bad args');
      };
    }

    if (args.length === 2) {
      if (typeof args[0] === 'function' && typeof args[1] === 'object') {
        return func(args[1], args[0]);
      }

      if (typeof args[0] === 'object' && typeof args[1] === 'function') {
        return func(args[0], args[1]);
      }

      throw new Error('bad args');
    }

    throw new Error('bad args');
  };
};